<template>
  <v-dialog
    v-model="value"
    persistent
    max-width="600px"
    scrollable
    class="scrollDesign"
  >
    <v-card>
      <v-card-title class="headline gradiente lighten-2 elevation-3">
        <span class="white--text">
          {{ isMassiveStudentOptions[isMassiveQrStudents].title }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs12>
            <v-card-text>
              <p style="font-size: 18px; text-align: center">
                {{ isMassiveStudentOptions[isMassiveQrStudents].description }}
              </p>

              <v-radio-group
                v-model="radioDes"
                row
                style="justify-content: center"
              >
                <v-radio
                  :label="$t('students.modal_qr.indefinite')"
                  value="Ind"
                  color="red"
                ></v-radio>
                <v-radio label="Periodo" value="period" color="red"></v-radio>
              </v-radio-group>

              <v-layout
                wrap
                row
                justify-center
                v-show="this.radioDes == 'period'"
              >
                <v-flex xs6 sm6 lg6>
                  <VueTimePickerTool
                    :titleDate="$t('students.modal_qr.start_date')"
                    titleTime="Hora inicial"
                    v-model="startDate"
                    class="pickPoll"
                    style="font-size: 1.1em; margin-top: 3px; margin-left: -5px"
                    :min="today"
                    location="up"
                  />
                </v-flex>
                <v-flex xs6 sm6 lg6>
                  <VueTimePickerTool
                    :titleDate="$t('students.modal_qr.end_date')"
                    titleTime="Hora de término"
                    v-model="endDate"
                    class="pickPoll"
                    style="font-size: 1.1em; margin-top: 3px; margin-left: -5px"
                    :min="today"
                    location="up"
                  />
                </v-flex>
              </v-layout>

              <v-select :items="reasons" v-model="selectedReason" solo />

              <v-textarea
                v-if="selectedReason === reasons[3].value"
                :label="$t('students.modal_qr.reason_to_suspend_the_qr')"
                v-model="obj.reason"
                solo
                auto-grow
                counter
                maxlength="100"
              ></v-textarea>
              <p style="color: gray; font-size: 11px">
                {{ $t('generic.qr_suspend.reason') }}
              </p>
            </v-card-text>

            <v-card-actions style="justify-content: center">
              <v-btn
                color="primary"
                small
                @click="close"
                style="padding: 17px; margin-right: 17px"
              >
                {{ $t('students.modal_qr.cancel') }}
              </v-btn>
              <v-btn
                color="black"
                small
                @click="imput"
                style="
                  padding: 17px;
                  margin-left: 17px;
                  color: white;
                  background: black;
                "
              >
                {{ $t('students.modal_qr.suspend') }}
              </v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <loading v-model="toast.loading" text="Trabajando..."></loading>
    <success
      v-model="toast.success"
      :text="isMassiveStudentOptions[isMassiveQrStudents].succes"
    ></success>
    <error v-model="toast.failed" :text="toast.fmessage"></error>
    <help
      v-model="helpDialog.flag"
      :title="helpDialog.title"
      :description="helpDialog.description"
    ></help>
    <alert
      v-model="toast.unauthorized"
      title="Aviso"
      :description="toast.description"
    ></alert>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import alert from '../Dialogs/Alert.vue'
import error from '../Dialogs/Error.vue'
import help from '../Dialogs/Help2.vue'
import loading from '../Dialogs/Loading.vue'
import success from '../Dialogs/Success.vue'
import VueTimePickerTool from '../Sections/Notices/Tools/DatePicker.vue'

export default {
  props: ['std', 'coll', 'par', 'value', 'student'],
  components: {
    loading,
    success,
    error,
    help,
    alert,
    VueTimePickerTool,
  },
  data: () => ({
    selectedReason: 'INDISCIPLINE',
    isMassiveStudentOptions: {
      true: {
        title: 'Suspender QRs',
        description:
          'Al suspender los QRs de estos usuarios permanecerán inválidos y no podrán utilizarse para el ingreso al colegio hasta que se activen nuevamente.',
        succes: 'QR Bloqueados correctamente',
        langKeyTitle: 'generic.qr_suspend.suspend_qr_title_one',
        langKeyDescription: 'generic.qr_suspend.suspend_qr_description_one',
      },
      false: {
        title: 'Suspender QR',
        description:
          'Al suspender el QR de este usuario permanecerá inválido y no podrá utilizarse para el ingreso al colegio hasta que se active nuevamente.',
        succes: 'QR Bloqueado correctamente',
        langKeyTitle: 'generic.qr_suspend.suspend_qr_title_many',
        langKeyDescription: 'generic.qr_suspend.suspend_qr_description_many',
      },
    },
    isMassiveQrStudents: false,
    radioDes: 'Ind',
    reasons: [
      {
        text: 'Indisciplina',
        value: 'INDISCIPLINE',
      },
      {
        text: 'Falta de pago',
        value: 'FAILED_PAYMENT',
      },
      {
        text: 'Retardos',
        value: 'DELAYS',
      },
      {
        text: 'Redactar motivo',
        value: 'OTHER',
      },
    ],
    obj: {
      disable: true,
      reason: '',
      id: '',
      start: null,
      endDate: null,
    },
    toast: {
      loading: false,
      success: false,
      failed: false,
      unauthorized: false,
      fmessage: 'Ups ocurrió un error',
      description: 'No cuentas con los permisos para realizar esta acción',
    },
    helpDialog: {
      title: '',
      description: '',
      flag: false,
    },
    startDate: '',
    endDate: '',
    today: '',
  }),

  methods: {
    setLang() {
      this.isMassiveStudentOptions.true.title = this.$t(
        this.isMassiveStudentOptions.true.langKeyTitle
      )
      this.isMassiveStudentOptions.true.description = this.$t(
        this.isMassiveStudentOptions.true.langKeyDescription
      )
      this.isMassiveStudentOptions.false.title = this.$t(
        this.isMassiveStudentOptions.false.langKeyTitle
      )
      this.isMassiveStudentOptions.false.description = this.$t(
        this.isMassiveStudentOptions.false.langKeyDescription
      )
    },
    close() {
      this.obj.reason = ''
      this.radioDes = 'Ind'
      this.startDate = ''
      this.endDate = ''
      this.selectedReason = this.reasons.at(0).value
      this.$emit('input', !this.value)
    },
    async imput() {
      if (
        this.selectedReason === this.reasons[3].value &&
        this.obj.reason === ''
      ) {
        this.helpDialog.title = ''
        if (this.std === true) {
          this.helpDialog.description =
            'Debes ingresar un motivo por el que deseas suspender el QR del alumno.'
        }
        if (this.coll === true) {
          this.helpDialog.description =
            'Debes ingresar un motivo por el que deseas suspender el QR del colaborador.'
        }
        if (this.par === true) {
          this.helpDialog.description =
            'Debes ingresar un motivo por el que deseas suspender el QR del tutor.'
        }
        this.helpDialog.flag = true
        return
      }
      const obj1 = {}
      this.obj.reason = this.obj.reason.replace(/(\r\n|\n|\r)/gm, ' ')
      this.obj.reason.trim()

      obj1.reason = this.obj.reason !== '' ? this.obj.reason : undefined

      if (this.radioDes == 'Ind') {
        obj1.disable = true
        obj1.start = undefined
        obj1.endDate = undefined
      }
      if (this.radioDes == 'period') {
        var startMili = new Date(this.startDate)
        obj1.start = startMili.getTime()
        var endtMili = new Date(this.endDate)
        obj1.endDate = endtMili.getTime()
      }
      this.toast.loading = true
      obj1.id = this.student.id

      //Alumno
      if (this.std === true) {
        if (this.isMassiveQrStudents) {
          const params = {
            ...obj1,
            reasonType: this.selectedReason,
            ids: this.student.map((e) => e.id),
          }
          try {
            await this.$store.dispatch('student/toggleMultipleQRStatus', params)
            this.toast.loading = false
            this.toast.success = true
            this.$emit(
              'updated',
              this.student.map((e) => ({
                ...e,
                qrEnabled: false,
                qrDisabledReason: obj1.reason,
              }))
            )
            this.close()
          } catch (error) {
            this.toast.loading = false
            this.toast.failed = true
          }
          return
        }

        this.$store
          .dispatch('student/blockQR', {
            ...obj1,
            reasonType: this.selectedReason,
          })
          .then((response) => {
            this.student.qrEnabled = response.data.entity.qrEnabled
            this.student.qrDisabledReason =
              response.data.entity.qrDisabledReason
            this.toast.loading = false
            this.toast.success = true
            this.$emit('updated', this.student)
            this.close()
          })
          .catch((error) => {
            this.toast.loading = false

            if (error.data && error.data.code === 1017) {
              this.toast.unauthorized = true
              this.close()
            } else this.toast.failed = true
          })
      }
      //Colaborador
      if (this.coll === true) {
        this.$store
          .dispatch('employee/blockQR', obj1)
          .then((response) => {
            this.student.qrEnabled = response.data.entity.qrEnabled
            this.student.qrDisabledReason =
              response.data.entity.qrDisabledReason
            this.toast.loading = false
            this.toast.success = true
            this.$emit('updated', this.student)
            this.close()
          })
          .catch((error) => {
            this.toast.loading = false

            if (error.data && error.data.code === 1017) {
              this.toast.unauthorized = true
              this.close()
            } else this.toast.failed = true
          })
      }
      //Tutor
      if (this.par === true) {
        this.$store
          .dispatch('tutor/blockQR', obj1)
          .then((response) => {
            this.student.qrEnabled = response.data.entity.qrEnabled
            this.student.qrDisabledReason =
              response.data.entity.qrDisabledReason
            this.toast.loading = false
            this.toast.success = true
            this.$emit('updated', this.student)
            this.close()
          })
          .catch((error) => {
            this.toast.loading = false

            if (error.data && error.data.code === 1017) {
              this.toast.unauthorized = true
              this.close()
            } else this.toast.failed = true
          })
      }
      // } else {
      //   this.helpDialog.title = ''
      //   if (this.std === true) {
      //     this.helpDialog.description =
      //       'Debes ingresar un motivo por el que deseas suspender el QR del alumno.'
      //   }
      //   if (this.coll === true) {
      //     this.helpDialog.description =
      //       'Debes ingresar un motivo por el que deseas suspender el QR del colaborador.'
      //   }
      //   if (this.par === true) {
      //     this.helpDialog.description =
      //       'Debes ingresar un motivo por el que deseas suspender el QR del tutor.'
      //   }
      //   this.helpDialog.flag = true
      // }
    },
  },
  mounted() {
    this.today = new Date().toLocaleDateString('sv-SE')
    this.setLang()
  },
  computed: {
    ...mapGetters(['getLang']),
  },
  watch: {
    value() {
      if (this.value === false) {
        this.selectedReason = this.reasons.at(0).value
      }
    },
    getLang() {
      this.setLang()
    },
    student() {
      if (Array.isArray(this.student)) {
        if (this.student.length === 1) {
          this.student = this.student[0]
        }
        this.isMassiveQrStudents = true
        return
      }

      this.isMassiveQrStudents = false
    },
  },
}
</script>

<style></style>
